/**
 * HemSyd: Gavokampanjer - "Kop X - fa en gava" (FLERA samtidigt).
 * Varje kampanj UPPREPAS: X produkter = 1 gava, 2X = 2, osv.
 *
 * ALLA kampanjer styrs fran metaobjekt (admin -> Innehall -> Metaobjekt ->
 * Gavokampanj) och skickas hit som ARRAY via window.HS_GIFT_CAMPAIGNS
 * (byggs i snippets/hemsyd-imao-gift.liquid). Guardad mot dubbelkorning -
 * snippeten renderas flera ganger per sida.
 *
 * KVALIFICERING (per kampanj): en varukorgsrad raknas om produktens ID
 * finns i kampanjens qualifyingIds ELLER om produkttypen matchar dess
 * productType. Gavorader (oavsett kampanj) raknas ALDRIG, och kampanjens
 * egna gavoprodukter raknas inte ens kopta till fullt pris - annars raknar
 * vi fler an Shopifys rabatt och kunden far en gava som aldrig blir gratis.
 *
 * GAVORAD <-> KAMPANJ: raden binds till sin kampanj via radegenskapen
 * "Present: <propValue>" - propValue ar unik per kampanj (antal + text).
 *
 * SA HANGER DET IHOP MED RABATTERNA: varje kampanj har en egen "Kop X fa
 * Y"-rabatt i admin som nollar priset pa gavor som redan ligger i korgen -
 * men ALDRIG lagger dit dem. Det gor det har skriptet. Urvalet MASTE
 * matcha rabattens kollektionsregler.
 *
 * VIKTIGT: antalet gavor per kampanj halls exakt pa floor(antal / troskel).
 * Fler an sa nollas inte av rabatten.
 */
(function () {
  'use strict';

  if (window.hemsydGiftInit) return;
  var CAMPS = window.HS_GIFT_CAMPAIGNS;
  if (!CAMPS || !CAMPS.length) return;
  window.hemsydGiftInit = true;

  var RELOAD_KEY = 'hsGiftReload';
  var busy = false;

  /* ── Anonym kampanjstatistik ──────────────────────────────────────────
     Raknar tratten (visning -> klick -> mal_natt -> gava_tillagd) EN gang
     per handelse, kampanj och besokssession (dedupe via sessionStorage).
     Skickas som beacon till crevo.se/hemsyd-bevaka - bara en raknare,
     inga personuppgifter/IP/kakor. text/plain ar MEDVETET: beaconen
     slipper da CORS-preflight. Statistiken far ALDRIG paverka butiken -
     darfor allt i try/catch och inga svar lases. */
  var STAT_URL = 'https://crevo.se/hemsyd-bevaka/api/kampanj.php';
  function stat(c, handelse) {
    try {
      var k = 'hsGiftStat_' + c.key + '_' + handelse;
      if (window.sessionStorage.getItem(k)) return;
      window.sessionStorage.setItem(k, '1');
      var data = JSON.stringify({ kampanj: c.key, handelse: handelse });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(STAT_URL, new Blob([data], { type: 'text/plain' }));
      } else {
        new Image().src = STAT_URL + '?kampanj=' + encodeURIComponent(c.key)
          + '&handelse=' + encodeURIComponent(handelse);
      }
    } catch (e) { /* statistik far aldrig krascha butiken */ }
  }

  /* Texter med generiska reserver + per-kampanj-arbetsyta. */
  CAMPS.forEach(function (c) {
    c.T = {
      items: c.itemsLabel || 'produkter',
      itemsSingle: c.itemsLabelSingle || 'produkt',
      gift: c.giftLabel || 'gåvan',
      reached: c.reachedText || 'Grattis! Din gåva ingår gratis',
      choose: c.chooseLabel || 'Välj din gåva:'
    };
    c.note = '';
    c.lastState = null;
  });

  function choiceKey(c) { return 'hsGiftChoice_' + c.key; }
  function lastKey(c) { return 'hsGiftLast_' + c.key; }

  function giftIds(c) {
    return c.gifts.map(function (g) { return g.id; });
  }

  function chosenId(c) {
    var saved = parseInt(window.localStorage.getItem(choiceKey(c)), 10);
    if (saved && giftIds(c).indexOf(saved) > -1) {
      var ok = c.gifts.filter(function (g) { return g.id === saved && g.available; })[0];
      if (ok) return saved;
    }
    var first = c.gifts.filter(function (g) { return g.available; })[0];
    return first ? first.id : null;
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function giftProps(c) {
    var p = {};
    p[c.prop] = c.propValue;
    return p;
  }

  /* Ar raden en GAVORAD - och i sa fall for vilken kampanj? */
  function giftLineOf(item) {
    if (!item.properties) return null;
    for (var i = 0; i < CAMPS.length; i++) {
      if (item.properties[CAMPS[i].prop] === CAMPS[i].propValue) return CAMPS[i];
    }
    return null;
  }

  /* Kvalificerar raden for kampanjen? Se kommentaren overst. */
  function qualifies(c, item) {
    var byId = c.qualifyingIds && c.qualifyingIds.length > 0
      && c.qualifyingIds.indexOf(item.product_id) > -1;
    var byType = c.productType && item.product_type === c.productType;
    return byId || byType;
  }

  function analyse(cart, c) {
    var ids = giftIds(c);
    var count = 0;
    var giftLines = [];
    var giftTotal = 0;
    cart.items.forEach(function (item) {
      var owner = giftLineOf(item);
      if (owner) {
        if (owner === c) {
          giftLines.push({ key: item.key, id: item.variant_id, qty: item.quantity });
          giftTotal += item.quantity;
        }
        return; // gavorader raknas aldrig som kvalificerande - for nagon kampanj
      }
      if (ids.indexOf(item.variant_id) > -1) return; // kampanjens gavoprodukt till fullt pris
      if (qualifies(c, item)) count += item.quantity;
    });
    return {
      count: count,
      giftLines: giftLines,
      giftTotal: giftTotal,
      entitled: Math.floor(count / c.threshold)
    };
  }

  function post(url, body) {
    busy = true;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      busy = false;
      return res.ok;
    }).catch(function () {
      busy = false;
      return false;
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function refresh() {
    return getCart().then(apply).catch(function () {});
  }

  /**
   * Efter att VI andrat varukorgen maste resten av temat fa veta det.
   * Utanfor /cart racker ajaxCart.load(). PA /cart ar raderna
   * server-renderade, sa sidan laddas om. Raknaren i sessionStorage ar ett
   * skydd mot omladdningsloop.
   */
  function afterChange() {
    if (isCartPage()) {
      var n = parseInt(window.sessionStorage.getItem(RELOAD_KEY) || '0', 10);
      if (n < 3) {
        window.sessionStorage.setItem(RELOAD_KEY, n + 1);
        window.location.reload();
        return;
      }
      refresh();
      return;
    }
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
    } else {
      refresh();
    }
  }

  function addGift(c, id, qty) {
    return post('/cart/add.js', { items: [{ id: id, quantity: qty, properties: giftProps(c) }] })
      .then(function (ok) {
        if (!ok) {
          c.note = 'Gåvan är tillfälligt slut i den varianten – välj en annan.';
        } else {
          c.note = '';
          stat(c, 'gava_tillagd');
        }
        return ok;
      });
  }

  /* Bantar ner till exakt "target" gavor bakifran. item.key, inte radnummer -
     radnumren flyttar sig nar en rad forsvinner. */
  function trimTo(giftLines, giftTotal, target) {
    var surplus = giftTotal - target;
    var chain = Promise.resolve();
    for (var i = giftLines.length - 1; i >= 0 && surplus > 0; i--) {
      var line = giftLines[i];
      var take = Math.min(surplus, line.qty);
      var left = line.qty - take;
      surplus -= take;
      (function (key, newQty) {
        chain = chain.then(function () {
          return post('/cart/change.js', { id: key, quantity: newQty });
        });
      })(line.key, left);
    }
    return chain;
  }

  function readLast(c) {
    try { return JSON.parse(window.sessionStorage.getItem(lastKey(c))); } catch (e) { return null; }
  }

  /**
   * Kor varje kampanj mot samma varukorgslage. Justeringar (lagg till/trimma
   * gavor) kedjas SEKVENTIELLT over alla kampanjer och avslutas med EN
   * gemensam afterChange - parallella cart-anrop krockar i Shopify.
   */
  function apply(cart) {
    var chain = Promise.resolve();
    var anyChange = false;

    CAMPS.forEach(function (c) {
      var state = analyse(cart, c);
      var prev = readLast(c);
      c.lastState = state;

      if (state.entitled >= 1) stat(c, 'mal_natt');

      /* Tog kunden bort en gava sjalv? Da ska den INTE studsa tillbaka - vi
         respekterar valet tills korgen andras igen. */
      var declined = state.giftTotal < state.entitled
        && prev && prev.count === state.count && prev.giftTotal > state.giftTotal;
      if (!declined && prev && prev.declinedAt === state.count && state.giftTotal < state.entitled) {
        declined = true;
      }

      window.sessionStorage.setItem(lastKey(c), JSON.stringify({
        count: state.count,
        giftTotal: state.giftTotal,
        declinedAt: declined ? state.count : null
      }));

      render(c, state, declined);

      if (busy) return;

      if (state.giftTotal > state.entitled) {
        anyChange = true;
        chain = chain.then(function () {
          return trimTo(state.giftLines, state.giftTotal, state.entitled);
        });
      } else if (state.giftTotal < state.entitled && !declined) {
        var want = chosenId(c);
        if (want) {
          anyChange = true;
          chain = chain.then(function () {
            return addGift(c, want, state.entitled - state.giftTotal);
          });
        }
      }
    });

    markGiftFree();
    setTimeout(markGiftFree, 500);
    setTimeout(markGiftFree, 1200);

    if (busy) return;
    if (anyChange) {
      chain.then(afterChange);
    } else {
      // Stabilt lage - nollstall omladdningsskyddet.
      window.sessionStorage.removeItem(RELOAD_KEY);
    }
  }

  /**
   * Klick pa en gava = "ge mig en till av den har" inom kampanjen. Vid max
   * byts en enhet ut fran den variant som har flest (inte den klickade) sa
   * totalen halls.
   */
  function chooseGift(c, id) {
    window.localStorage.setItem(choiceKey(c), id);
    window.sessionStorage.removeItem(lastKey(c));

    getCart().then(function (cart) {
      var state = analyse(cart, c);
      if (state.entitled < 1) { render(c, state, false); return; }

      var onlyThis = state.giftLines.length === 1
        && state.giftLines[0].id === id
        && state.giftTotal === state.entitled;
      if (onlyThis) { render(c, state, false); return; }

      var chain = Promise.resolve();
      if (state.giftTotal >= state.entitled) {
        var victim = null;
        state.giftLines.forEach(function (l) {
          if (l.id === id) return;
          if (!victim || l.qty > victim.qty) victim = l;
        });
        if (!victim) victim = state.giftLines[0];
        if (victim) {
          chain = chain.then(function () {
            return post('/cart/change.js', { id: victim.key, quantity: victim.qty - 1 });
          });
        }
      }

      chain
        .then(getCart)
        .then(function (cart2) {
          // Nycklarna kan ha andrats av borttagningen - hamta om.
          var st2 = analyse(cart2, c);
          var mine = st2.giftLines.filter(function (l) { return l.id === id; })[0];
          if (mine) return post('/cart/change.js', { id: mine.key, quantity: mine.qty + 1 });
          return post('/cart/add.js', { items: [{ id: id, quantity: 1, properties: giftProps(c) }] });
        })
        .then(function (ok) {
          if (!ok) {
            c.note = 'Gåvan är tillfälligt slut i den varianten – välj en annan.';
            return refresh();
          }
          c.note = '';
          afterChange();
        });
    });
  }

  /**
   * Cart-panelens Handlebars-mall renderar ODISKONTERAT radpris - gavoraden
   * stod pa fullpris i panelen trots ratt total. Skrivs om till "Gratis" +
   * overstruket pris. Raden hittas via SIN EGEN TEXT (egenskapen
   * "Present: ..."), aldrig via radnummer - panelen ritas om asynkront och
   * radnummer traffar fel rad.
   */
  function markGiftFree() {
    var rows = document.querySelectorAll('.velaAjaxCartModal .ajaxCartRow');
    if (!rows.length) return;
    var values = [];
    CAMPS.forEach(function (c) {
      if (c.lastState && c.lastState.entitled >= 1 && c.lastState.giftTotal >= 1) {
        values.push(c.propValue);
      }
    });
    if (!values.length) return;
    for (var i = 0; i < rows.length; i++) {
      var meta = rows[i].querySelector('.headerCartProductMeta');
      if (!meta) continue;
      var hit = false;
      for (var v = 0; v < values.length; v++) {
        if (meta.textContent.indexOf(values[v]) > -1) { hit = true; break; }
      }
      if (!hit) continue;
      var priceEl = rows[i].querySelector('.headerCartPrice');
      if (!priceEl || priceEl.dataset.hsGiftDone) continue;
      var was = priceEl.textContent.trim();
      priceEl.dataset.hsGiftDone = '1';
      priceEl.dataset.hsSaleDone = '1';
      priceEl.innerHTML = '<span class="hsCartSalePrice">Gratis</span>'
        + (was ? '<span class="hsCartSaleCompare">' + was + '</span>' : '');
    }
  }

  function qtyOf(state, id) {
    var n = 0;
    state.giftLines.forEach(function (l) { if (l.id === id) n += l.qty; });
    return n;
  }

  function render(c, state, declined) {
    var T = c.T;
    var reached = state.entitled >= 1;
    var toNext = c.threshold - (state.count % c.threshold);
    var pct = reached ? 100 : (state.count / c.threshold) * 100;
    var bars = document.querySelectorAll('.hemsyd-gift-bar[data-hs-camp="' + c.key + '"]');

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];

      // Inga kvalificerande produkter i korgen = dolj kampanjen helt.
      if (state.count === 0 && !state.giftLines.length) {
        bar.hidden = true;
        continue;
      }
      bar.hidden = false;
      stat(c, 'visning');
      bar.classList.toggle('is-complete', reached && !declined);

      var text = bar.querySelector('.hemsyd-gift-text');
      if (text) {
        if (declined) {
          text.textContent = 'Du kan lägga till din gratis ' + T.gift + ' igen';
        } else if (!reached) {
          text.textContent = (toNext === 1
            ? '1 ' + T.itemsSingle
            : toNext + ' ' + T.items) + ' kvar till gratis ' + T.gift;
        } else {
          text.textContent = state.entitled === 1
            ? T.reached
            : T.reached + ' (' + state.entitled + ' st)';
        }
      }

      var fill = bar.querySelector('.hemsyd-gift-fill');
      if (fill) fill.style.width = pct + '%';

      var choices = bar.querySelector('.hemsyd-gift-choices');
      var row = bar.querySelector('.hemsyd-gift-choices-row');
      var label = bar.querySelector('.hemsyd-gift-choices-label');
      if (choices && row) {
        choices.hidden = !reached;
        if (label) {
          label.textContent = declined
            ? 'Välj nedan så lägger vi tillbaka den:'
            : T.choose;
        }
        if (reached) {
          var fallback = chosenId(c);
          var html = '';
          for (var g = 0; g < c.gifts.length; g++) {
            var gift = c.gifts[g];
            var n = qtyOf(state, gift.id);
            var active = declined ? false : (n > 0 || (state.giftTotal === 0 && gift.id === fallback));
            html += '<button type="button" class="hemsyd-gift-choice'
              + (active ? ' is-active' : '')
              + '" data-hs-camp-key="' + c.key + '" data-hs-gift-id="' + gift.id + '"'
              + (gift.available ? '' : ' disabled')
              + '><img src="' + gift.img + '" alt="" loading="lazy"><span>'
              + gift.short + (n > 1 ? ' ×' + n : '') + '</span></button>';
          }
          if (row.innerHTML !== html) row.innerHTML = html;
        }
      }

      /* Notraden: felmeddelande i forsta hand, annars puff for nasta gava. */
      var noteEl = bar.querySelector('.hemsyd-gift-note');
      if (noteEl) {
        var msg = c.note;
        if (!msg && reached && !declined) {
          msg = 'Lägg till ' + (toNext === 1 ? '1 ' + T.itemsSingle : toNext + ' ' + T.items)
            + ' till – få ytterligare en gratis';
        }
        noteEl.hidden = !msg;
        noteEl.textContent = msg;
      }
    }
  }

  function campByKey(key) {
    return CAMPS.filter(function (c) { return c.key === key; })[0] || null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-hs-gift-id]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var camp = campByKey(btn.getAttribute('data-hs-camp-key'));
    if (!camp) return;
    stat(camp, 'klick');
    btn.classList.add('is-busy');
    chooseGift(camp, parseInt(btn.getAttribute('data-hs-gift-id'), 10));
  });

  // ajaxCart.afterCartLoad triggas efter varje add/remove/qty-andring.
  if (window.jQuery) {
    window.jQuery('body').on('ajaxCart.afterCartLoad', function (_e, cart) {
      if (cart && cart.items) { apply(cart); } else { refresh(); }
    });
    window.jQuery(document).on('submit', '.formAddToCart', function () {
      setTimeout(refresh, 700);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
